var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwipe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28198",
    "data-name": "Rectangle 28198",
    width: 47,
    height: 47,
    transform: "translate(708 3613)",
    fill: "#c3d0da",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28197",
    "data-name": "Rectangle 28197",
    width: 35,
    height: 47,
    transform: "translate(0.25)",
    fill: "#c3d0da"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "swipe",
    transform: "translate(-708 -3613)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68028",
    "data-name": "Group 68028",
    transform: "translate(713.75 3613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68028-2",
    "data-name": "Group 68028",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158446",
    "data-name": "Path 158446",
    d: "M30.852,22.537h-.825a3.767,3.767,0,0,0-2.656-.87H25.63V9.481c0-.861,0-3.481-3.481-3.481-2.9,0-3.384,1.817-3.464,2.922a4.507,4.507,0,0,0-1.758-.311c-3.481,0-3.481,2.621-3.481,3.481V29.5a1.98,1.98,0,0,1-.111.771c-.166-.032-.724-.227-1.884-1.386-2.13-2.13-4.486-2.956-6.306-2.2A3.716,3.716,0,0,0,3,30.372a.868.868,0,0,0,.255.615,37.584,37.584,0,0,1,6.8,9.346c2.47,4.939,6.832,7.444,12.964,7.444,7.858,0,12.185-4.327,12.185-12.185V28.63c0-3.815-1.627-6.093-4.352-6.093m-7.833,23.5c-5.419,0-9.256-2.181-11.407-6.482a39.4,39.4,0,0,0-6.856-9.527,1.894,1.894,0,0,1,1.053-1.737c.845-.352,2.5-.079,4.409,1.824,1.018,1.018,2.517,2.308,3.8,1.78.53-.22,1.163-.815,1.163-2.4V12.093c0-.972,0-1.741,1.741-1.741s1.741.769,1.741,1.741V25.148c0,1.741.87,2.611,1.741,2.611V9.481c0-.972,0-1.741,1.741-1.741s1.741.769,1.741,1.741v14.8c0,1.741.87,2.611,1.741,2.611V23.407H27.37c1.6,0,1.731.746,1.741.87,0,1.741.87,2.611,1.741,2.611V24.278c2.357,0,2.611,3.044,2.611,4.352v6.963c0,6.931-3.514,10.444-10.444,10.444",
    transform: "translate(-0.389 -0.778)",
    fill: "#c3d0da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158447",
    "data-name": "Path 158447",
    d: "M25.241.87A.87.87,0,0,0,24.37,0H.87a.87.87,0,0,0,0,1.741h23.5a.87.87,0,0,0,.87-.87",
    fill: "#c3d0da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158448",
    "data-name": "Path 158448",
    d: "M17.926,4.87a.87.87,0,0,0-.87-.87H4.87a.87.87,0,1,0,0,1.741H17.056a.87.87,0,0,0,.87-.87",
    transform: "translate(-0.519 -0.519)",
    fill: "#c3d0da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158449",
    "data-name": "Path 158449",
    d: "M8.87,8a.87.87,0,0,0,0,1.741h2.611a.87.87,0,0,0,0-1.741Z",
    transform: "translate(-1.037 -1.037)",
    fill: "#c3d0da"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipe);
export default __webpack_public_path__ + "static/media/swipe.eab575bd53537e28f79b8daf94e960a2.svg";
export { ForwardRef as ReactComponent };